import { useEffect, useState } from "react";
import { NAV_LINKS, LOGO_URL } from "@/lib/data";
import { waLink } from "@/lib/whatsapp";
import { Menu, X } from "lucide-react";

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-black/60 border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-3 group"
        >
          <img
            src={LOGO_URL}
            alt="Flyora Weddings"
            className="h-16 md:h-20 w-auto object-contain [mix-blend-mode:screen]"
          />
          <span className="hidden lg:inline font-mono-label text-[10px] text-[#8F8F8F] border-l border-white/20 pl-3">
            A Flyfilms Production
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              data-testid={`nav-link-${link.label.toLowerCase()}`}
              href={link.href}
              className="font-mono-label text-[11px] text-[#FDFBF7]/80 hover:text-[#C4A484] transition-colors link-underline"
            >
              {link.label}
            </a>
          ))}
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-cta-whatsapp"
            className="font-mono-label text-[11px] px-5 py-2.5 border border-[#C4A484] text-[#C4A484] hover:bg-[#C4A484] hover:text-black transition-all duration-500"
          >
            Book a Call
          </a>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-[#FDFBF7]"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden bg-black/95 backdrop-blur-xl border-t border-white/10 px-6 py-8 flex flex-col gap-6"
        >
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setOpen(false)}
              className="font-heading text-2xl tracking-tighter"
              data-testid={`nav-mobile-link-${link.label.toLowerCase()}`}
            >
              {link.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}
